import React from 'react'
import './PlaceOrder.css';

const PlaceOrder = () => {
  return (
    <div>
      
    </div>
  )
}

export default PlaceOrder
